angular.module('app')
	.controller('HomeCtrl', function (
		$scope,
		$rootScope,
		FactoryObj,
		$notificationService,
		$contractService,
		$userService,
		$configService,
		$window,
		$location,
		$transactionFactory,
		$modalService,
		$financialApiService,
		$arcService,
		$download,
		$uniService,
		$typeDomainService
	) {
		$scope.loaderFirma = [];
		$scope.appCertificate = null;
		$scope.$configService = $configService;

		if ($configService.getUser().status != propMap['USER_STATUS_NEW_USER']) {
			$scope.certificateIC = $configService.getAppConfig().certificate;
			if ($scope.certificateIC) {
				var emissione = new Date($scope.certificateIC.dataEmissione);
				$scope.certificateIC.dataScadenza = new Date($scope.certificateIC.dataEmissione);
				$scope.certificateIC.dataScadenza.setFullYear(emissione.getFullYear() + 3);
			}
		}

		$scope.flags = {
			noCertificate: null
		}

		$scope.digitalSignature = {
			acceptTermsCheckbox: false,
			pin: null,
			confirmPin: null,
			otp: null
		};

		$scope.changeHomeIndex = function (view) {
			$scope.homeIndex = view;
		}

		if ($configService.getUser().status == propMap['USER_STATUS_NEW_USER']) {
			$rootScope.goTo('/registerVendor');
		}

		$scope.portal = "aru";

		$scope.initialize = function () {
			/** init services **/
			$scope.callInfoDisconnections();
			
			$scope.lastNotification = 0;
			$scope.$contractService = $contractService;
			$scope.notificationService = $notificationService;
			$scope.$rootScope = $rootScope;
			$scope.appUser = {
				emailNsil: null,
				email: null,
			};

			/** check certificate */
			$scope.flags.noCertificate = !$userService.hasValidCertificate();

			/** init other stuff.. **/
			$scope.initializeNotification();


			var url = $location.absUrl();
			if (url.indexOf("infocertRedirect") > 1) {
				var input = url.split('infocertRedirect=')[1];
				$contractService.updateSignedDossier(input)
					.then(function () {
						$scope.getAllSignedContracts();
					})
			} else {
				$scope.getAllSignedContracts();
			}


			if ($configService.getUser().type == "CUSTOMER_IL" &&
				$configService.getUser().subType &&
				$configService.getUser().subType == "INSTANT") {
				$scope.homeIndex = "inner-view-contract-selection";
			} else if ($configService.getUser().type == "SIGNER") {
				$scope.homeIndex = "inner-view-contract-selection";
				$scope.popolateCertificate();
			} else if ($configService.getUser().type == "ASSOCIATE_PERSON") {
				$scope.homeIndex = "inner-view-personal-doc";
			} else {
				$scope.homeIndex = "inner-view-digital-table-selection"
			}

			if (($configService.getUserStatus() == "ENABLED" && !JSON.parse(localStorage.getItem("canPostpone")) || $configService.getUser().underVerification)) {
				$scope.notificationService
					.getNotificationOverlay()
					.then(function (notification) {
						if (notification != null) {

							$scope.openModalOverlayNotification(notification, true);
						}
					});
			}
			$scope.listLateralButton = $configService.getAppConfig().sideMenu;
			$scope.getAlertForUser();

		}

		$scope.initializeNotification = function () {
			$notificationService.getUserNotifications()
				.then(function (response) {
					$scope.notificationsList = response;
				});
		}

		$scope.getAlertForUser = function () {
			$financialApiService.getAlertForUser()
				.then(function (response) {
					$scope.numberOfComunication = response.id_comunications_board;
					$rootScope.numeroArchivioDocUnread = response.id_archivio_docs;
					$rootScope.$broadcast("restFinish", {
						comunications: response
					});
				})
		}

		$scope.acceptTerms = function () {
			$scope.digitalSignature.acceptTermsCheckbox = !$scope.digitalSignature.acceptTermsCheckbox;
		}

		$scope.checkNotificationsCarouselArrows = function () {
			//wait for angular to add class Active to the first slide
			setTimeout(function () {
				if ($('.carousel-inner .item').length == 1) {
					$('.carousel-control').hide();
				} else {
					if ($('.carousel-inner .item:first').hasClass('active')) {
						$('.up.carousel-control').hide();
						$('.down.carousel-control').show();
					} else if ($('.carousel-inner .item:last').hasClass('active')) {
						$('.up.carousel-control').show();
						$('.down.carousel-control').hide();
					} else {
						$('.carousel-control').show();
					}
				}
			}, 0);
		}

		// TABLE VIEW

		$scope.customerListSortKey = "signedStatus";
		$scope.customerListReverse = false;

		$scope.filterTools = {
			enableFilters: false,
			limit: window.innerHeight > 620 ? '6' : '4',
			pageIndex: 1,
			openSearch: '',
			offset: 0,
			totalPages: 0,
			orderColumnName: 'INSERT_DATE',
			orderType: 'DESC'
		};

		$scope.contractList = [];

		$scope.getAllSignedContracts = function () {
			$contractService.getAllSignedContracts()
				.then(function (list) {
					$scope.sortedContractList = list
						.filter(function (contract) {
							return contract.signedStatus < 10
						})
						.sort(function (a, b) {
							if (a.updateDate > b.updateDate) return -1;
							if (a.updateDate < b.updateDate) return 1;
							return 0;
						});

					$scope.filterTools.totalPages = $scope.sortedContractList.length;
					//$scope.contractList = $scope.addEmptyRow($scope.sortedContractList);
					$scope.contractList = $scope.sortedContractList;


				})
		}


		$scope.selectContract = function (contract) {
			FactoryObj.selectedContract = contract;
			FactoryObj.appCertificate = $scope.appCertificate;
			$rootScope.goTo('/signedContracts');
		}


		/** FE pagiantion */
		$scope.contractListSortFunction = function (headerName, headerOrder) {
			self.customerListSortKey = headerName; //set the sortKey to the param passed
			if (headerOrder == 'up') {
				customerListReverse = false;
			} else {
				customerListReverse = true;
			}

		}

		$scope.hideSortArrow = function (headerName, headerOrder) {
			if (self.customerListSortKey == headerName) {
				if (headerOrder == 'up' &&
					self.customerListReverse == false) {
					return true;
				}
				if (headerOrder == 'down' &&
					self.customerListReverse == true) {
					return true;
				}
			}
			return false;
		}
		/** FE pagiantion END */

		$scope.addEmptyRow = function (restList) {
			var outputList = [];
			var indexRestList = Number($scope.filterTools.limit);
			if (restList != null) {
				outputList = restList;
				indexRestList = Number($scope.filterTools.limit) - restList.length;
			}

			if (indexRestList > 0) {
				for (var irl = 0; irl < indexRestList; irl++) {
					outputList.push({});
				}
			}
			return outputList;
		}

		$scope.generateGuideDownloadLink = function (value) {

			var url = value

			$download.getGenericDownload(url)
				.then(function (response) {
					console.log(response);
				})

		}

		$scope.getDossierUrl = function (dossierId, index) {
			$scope.loaderFirma[index] = true;
			$contractService.getDossierUrl(dossierId)
				.then(function (response) {
					if (response.success) {
						var url = response.dossierUrl;
						$window.open(url, '_blank');
						$scope.loaderFirma = false;
					}

				})
				.catch(function (error) {
					console.log(error);
					$scope.loaderFirma = false;

				})
		}

		$scope.onPressSearch = function (value) {
			$scope.filter = value;
		}

		$scope.onStartNewRequest = function (value) {
			$scope.pressNewRequest = !$scope.pressNewRequest
		}

		$scope.readNotification = function (notification) {
			$scope.showLoaderModal = true;
			if (notification.function === 'AGGIORNAMENTO_ADV_NEW' || notification.function === 'AGGIORNAMENTO_ADV') {
				$uniService.startQuestionarioArc()
					.then(response => {
						self.responseStartQuestionarioArc = response;

						$notificationService.readNotification(notification.id)
							.then(function () {
								$scope.lastNotification = notification.id;
								notification.read = true;
								$transactionFactory.set(self.responseStartQuestionarioArc);
								$location.path(self.responseStartQuestionarioArc.targetWizard);
								$scope.showLoaderModal = false;
								$modalService.closeModal('notificationOverlay-inner-component-modal');
							})
							.catch(function (error) {
								console.log(error);
								$scope.showLoaderModal = false;
							});

					}).catch(error => {
						$scope.showLoaderModal = false;
					})

			} else {
				$notificationService.readNotification(notification.id)
					.then(function () {
						$scope.lastNotification = notification.id;
						notification.read = true;
						if (notification.goToFunction) {
							switch (notification.function) {
								case 'AGGIORNAMENTO_DOC_IDENTITA':
									$arcService.getLinkedPersonDocScaduto()
										.then(function (response) {
											Object.assign(response, {
												isModalUpgradeDoc: true
											})
											$transactionFactory.set(response);
											$location.path(response.targetWizard);
											$scope.showLoaderModal = false;
											$modalService.closeModal('notificationOverlay-inner-component-modal');
										})
										.catch(function (error) {
											$scope.showLoaderModal = false;
										})
									break;
								case 'NUOVO_RESP_UTENZA':
									$arcService.getLinkedNewRespUtenza()
										.then(function (response) {
											$transactionFactory.set(response);
											$location.path(response.targetWizard);
											$scope.showLoaderModal = false;
											$modalService.closeModal('notificationOverlay-inner-component-modal');
										})
										.catch(function (error) {
											$scope.showLoaderModal = false;
										})
									break;
								case 'LOGOUT':
									$rootScope.logout();
									break;
								default:
									break;
							}
						} else {
							$scope.showLoaderModal = false;
							$modalService.closeModal('notificationOverlay-inner-component-modal');
						}
					})
					.catch(function (error) {
						console.log(error);
						$scope.showLoaderModal = false;
					});

			}

		}

		$scope.openModalOverlayNotification = function (notification, isLogin) {
			if (notification.canUpdate) {
				var temp = JSON.parse(notification.content);
				$scope.appUser = {
					emailNsil: temp.emailNsil,
					email: temp.email,
				};
			}
			$scope.notificationModal = notification;
			$scope.notificationModal.isLogin = isLogin;
			$modalService.openModal('notificationOverlay-inner-component-modal');
		};

		$scope.generatePdfDownloadLink = function (pdfLink) {
			var url =
				"/uni/downloadDocBacheca/service-infos/?downloadKey=" +
				encodeURIComponent(pdfLink)

			$download.getGenericDownload(url)
				.then(function (response) {
					console.log(response);
				})


		};

		$scope.viewUrl = function (url) {
			window.open(url, '_blank');
		}

		$scope.popolateCertificate = function () {
			$userService.getCertificatoFirma()
				.then(function (response) {
					if (response.success) {
						$scope.certificateIC = response.getCertFirmaResponse.certResponse.listCertificatoFirma[0];
						$scope.certificateIC.dataScadenza = moment($scope.certificateIC.dataEmissione).add(3, "years").format("DD/MM/YYYY");
						$scope.certificateIC.dataEmissione = moment($scope.certificateIC.dataEmissione).format("DD/MM/YYYY");
					}

				})
		}

		$scope.filterExported = function (value) {

			$scope.filter = value;

		}

		$scope.closeModalNotification = function (notification) {
			localStorage.setItem('canPostpone', notification.canPostpone);
			$modalService.closeModal('notificationOverlay-inner-component-modal');
		}

		$scope.restIsPending = function (value) {
			$scope.loaderRestCalling = value;
		}

		$scope.updateUser = function () {
			$scope.showLoaderModal = true;
			$arcService.updateProfileUser($scope.appUser)
				.then(function (response) {
					if (response.success) {
						$rootScope.$broadcast("addAlert", {
							text: "UPDATE_USER_MAIL_OK"

						})
						$modalService.closeModal('notificationOverlay-inner-component-modal');
						$scope.appUser.flagConfermaEmail = false;
					} else if(response.keyMessage == "ERROR_REMEDIATED_MANCATO_RECAPITO") {
						$scope.appUser.flagConfermaEmail = true;
					}
					$scope.showLoaderModal = false;

				})
				.catch(function (error) {
					$scope.showLoaderModal = false;
				})
		}

		$scope.confirmDealer = function () {
			$scope.showLoaderConfermDealer = true;
			$userService.confirmDealer()
				.then(function (response) {
					if (response.success) {
						$modalService.closeModal('notificationOverlay-inner-component-modal');
					}
					$scope.showLoaderConfermDealer = false;
				})
				.catch(function (error) {
					console.log(error);
					$scope.showLoaderConfermDealer = false;
				})
		}

		$scope.callInfoDisconnections = function () {

			$typeDomainService.getDomainSetUncached('NOTIFICA', 'HOME_ARC')
				.then(function (response) {
					console.log(response);
					if (response.success) {
						$scope.showAlertMessage = response.domainList && response.domainList[0];
					}

				})

		}

		$scope.openCloseNotification = function (id) {

			if (jQuery('#' + id).hasClass("show")) {
				jQuery('#button-' + id)
					.addClass("fa-plus-circle")
					.removeClass("fa-minus-circle");
				jQuery('#' + id).collapse('hide');
			} else {
				jQuery('#button-' + id)
					.removeClass("fa-plus-circle")
					.addClass("fa-minus-circle");
				jQuery('#' + id).collapse('show');
			}
		}

	})